// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* KYC filters */
.kyc-filters {
  padding: 0 1.25rem 1rem;
}

.kyc-search {
  width: 100%;
  max-width: 320px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
}

.kyc-search:focus {
  outline: none;
  border-color: #0f766e;
}

.kyc-error {
  margin: 0 1.25rem 1rem;
  padding: 0.75rem 1rem;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: var(--radius);
  font-size: 0.9rem;
}

/* KYC: status tabs */
.kyc-tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0 1.25rem 0;
  border-bottom: 1px solid var(--border);
  background: #fff;
}

.kyc-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  color: var(--text-muted);
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  margin-bottom: -1px;
}

.kyc-tab:hover {
  color: var(--text);
}

.kyc-tab--active {
  color: #0f766e;
  border-bottom-color: #0f766e;
}

.kyc-tab__count {
  min-width: 22px;
  padding: 0.15rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  background: var(--main-bg);
  color: var(--text-muted);
  border-radius: 10px;
  text-align: center;
}

.kyc-tab--active .kyc-tab__count {
  background: #ccfbf1;
  color: #0f766e;
}

/* KYC table */
.kyc-content-inner {
  padding: 1.25rem;
}

.kyc-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.kyc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.kyc-table thead {
  background: #f8fafc;
}

.kyc-table th {
  padding: 0.85rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  border-bottom: 2px solid var(--border);
}

.kyc-table td {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--border);
  color: var(--text);
}

.kyc-table tbody tr:hover {
  background: #f8fafc;
}

.kyc-table__empty {
  text-align: center;
  color: var(--text-muted);
  padding: 2rem !important;
}

.kyc-table__actions {
  white-space: nowrap;
}

.kyc-table__actions .btn-icon {
  margin: 0 2px;
}

.kyc-view-btn {
  padding: 0.35rem 0.75rem;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.kyc-table__user {
  max-width: 280px;
  font-size: 0.85rem;
}

.kyc-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 0 0;
  flex-wrap: wrap;
}

.kyc-pagination__info {
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
}

.kyc-pagination__buttons {
  display: flex;
  gap: 0.5rem;
}

.kyc-pagination__btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.kyc-pagination__btn:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
  border-color: #0f766e;
}

.kyc-pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* KYC status badges */
.badge--kyc-pending {
  background: #fef3c7;
  color: #92400e;
}

.badge--kyc-approved {
  background: #dcfce7;
  color: #166534;
}

.badge--kyc-rejected {
  background: #fee2e2;
  color: #b91c1c;
}

/* Action buttons (reuse + KYC specific) */
.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: var(--radius);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.85rem;
  transition: transform 0.15s, background 0.15s;
}

.btn-icon:hover {
  transform: scale(1.08);
}

.btn-icon--view {
  background: #dbeafe;
  color: #0f766e;
}

.btn-icon--view:hover {
  background: #bfdbfe;
}

.btn-icon--approve {
  background: #dcfce7;
  color: #15803d;
}

.btn-icon--approve:hover {
  background: #bbf7d0;
}

.btn-icon--reject {
  background: #fee2e2;
  color: #b91c1c;
}

.btn-icon--reject:hover {
  background: #fecaca;
}

/* Modal */
.kyc-reject-info {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  color: var(--text);
}

.btn-danger {
  background: #dc2626;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  border-radius: var(--radius);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-danger:hover {
  background: #b91c1c;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal {
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 440px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal--md {
  max-width: 480px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--border);
}

.modal-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--text);
}

.modal-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--radius);
  background: transparent;
  color: var(--text-muted);
  font-size: 1.1rem;
  cursor: pointer;
}

.modal-close:hover {
  background: var(--main-bg);
  color: var(--text);
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
}

.modal-field {
  margin-bottom: 1rem;
}

.modal-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text);
}

.modal-field input {
  width: 100%;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
  color: var(--text);
}

.modal-field input:focus {
  outline: none;
  border-color: #14b8a6;
}

.detail-list {
  margin: 0;
  padding: 0;
}

.detail-list__row {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid var(--border);
}

.detail-list__row:last-of-type {
  border-bottom: none;
}

.detail-list dt {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted);
  min-width: 100px;
  flex-shrink: 0;
}

.detail-list dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
}

.modal-footer .btn {
  min-width: 90px;
}

.btn-secondary {
  background: var(--main-bg);
  color: var(--text);
  border: 1px solid var(--border);
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  border-radius: var(--radius);
  cursor: pointer;
}

.btn-primary {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  border-radius: var(--radius);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/KYC/KYCManagementPage.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* KYC filters */\n.kyc-filters {\n  padding: 0 1.25rem 1rem;\n}\n\n.kyc-search {\n  width: 100%;\n  max-width: 320px;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n}\n\n.kyc-search:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.kyc-error {\n  margin: 0 1.25rem 1rem;\n  padding: 0.75rem 1rem;\n  background: #fee2e2;\n  color: #b91c1c;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n}\n\n/* KYC: status tabs */\n.kyc-tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0 1.25rem 0;\n  border-bottom: 1px solid var(--border);\n  background: #fff;\n}\n\n.kyc-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.25rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s;\n  margin-bottom: -1px;\n}\n\n.kyc-tab:hover {\n  color: var(--text);\n}\n\n.kyc-tab--active {\n  color: #0f766e;\n  border-bottom-color: #0f766e;\n}\n\n.kyc-tab__count {\n  min-width: 22px;\n  padding: 0.15rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: var(--main-bg);\n  color: var(--text-muted);\n  border-radius: 10px;\n  text-align: center;\n}\n\n.kyc-tab--active .kyc-tab__count {\n  background: #ccfbf1;\n  color: #0f766e;\n}\n\n/* KYC table */\n.kyc-content-inner {\n  padding: 1.25rem;\n}\n\n.kyc-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.kyc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.kyc-table thead {\n  background: #f8fafc;\n}\n\n.kyc-table th {\n  padding: 0.85rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n  border-bottom: 2px solid var(--border);\n}\n\n.kyc-table td {\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--border);\n  color: var(--text);\n}\n\n.kyc-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.kyc-table__empty {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 2rem !important;\n}\n\n.kyc-table__actions {\n  white-space: nowrap;\n}\n\n.kyc-table__actions .btn-icon {\n  margin: 0 2px;\n}\n\n.kyc-view-btn {\n  padding: 0.35rem 0.75rem;\n  font-size: 0.85rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.kyc-table__user {\n  max-width: 280px;\n  font-size: 0.85rem;\n}\n\n.kyc-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 0 0;\n  flex-wrap: wrap;\n}\n\n.kyc-pagination__info {\n  font-size: 0.875rem;\n  color: var(--text-muted, #64748b);\n}\n\n.kyc-pagination__buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.kyc-pagination__btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.kyc-pagination__btn:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n  border-color: #0f766e;\n}\n\n.kyc-pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* KYC status badges */\n.badge--kyc-pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.badge--kyc-approved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.badge--kyc-rejected {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n/* Action buttons (reuse + KYC specific) */\n.btn-icon {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: transform 0.15s, background 0.15s;\n}\n\n.btn-icon:hover {\n  transform: scale(1.08);\n}\n\n.btn-icon--view {\n  background: #dbeafe;\n  color: #0f766e;\n}\n\n.btn-icon--view:hover {\n  background: #bfdbfe;\n}\n\n.btn-icon--approve {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.btn-icon--approve:hover {\n  background: #bbf7d0;\n}\n\n.btn-icon--reject {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.btn-icon--reject:hover {\n  background: #fecaca;\n}\n\n/* Modal */\n.kyc-reject-info {\n  margin: 0 0 1rem;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.btn-danger {\n  background: #dc2626;\n  color: #fff;\n  border: none;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  border-radius: var(--radius);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.btn-danger:hover {\n  background: #b91c1c;\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.modal {\n  background: var(--card-bg);\n  border-radius: var(--radius);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 440px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal--md {\n  max-width: 480px;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.modal-close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: var(--radius);\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 1.1rem;\n  cursor: pointer;\n}\n\n.modal-close:hover {\n  background: var(--main-bg);\n  color: var(--text);\n}\n\n.modal-body {\n  padding: 1.5rem;\n  overflow-y: auto;\n}\n\n.modal-field {\n  margin-bottom: 1rem;\n}\n\n.modal-field label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.modal-field input {\n  width: 100%;\n  padding: 0.65rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n  color: var(--text);\n}\n\n.modal-field input:focus {\n  outline: none;\n  border-color: #14b8a6;\n}\n\n.detail-list {\n  margin: 0;\n  padding: 0;\n}\n\n.detail-list__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 0.6rem 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.detail-list__row:last-of-type {\n  border-bottom: none;\n}\n\n.detail-list dt {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  min-width: 100px;\n  flex-shrink: 0;\n}\n\n.detail-list dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border);\n}\n\n.modal-footer .btn {\n  min-width: 90px;\n}\n\n.btn-secondary {\n  background: var(--main-bg);\n  color: var(--text);\n  border: 1px solid var(--border);\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  border-radius: var(--radius);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
